import { FC } from 'react'

import MediaCard from './common/MediaCard'
import { getPlanPrice } from 'common/utils/planPrice'
import { PlanSlug } from 'common/planSlugs'
import { TPlanSummary } from 'common/cms-types'
import SubscriptionPricing from 'components/SubscriptionPricing'
import { ButtonType } from '../../../types/global'

type Props = {
  planSummary: TPlanSummary
}

const SetupVOin10: FC<Props> = ({ planSummary }) => {
  return (
    <MediaCard
      layout={{
        desktop: 'content-right-media-left',
        mobile: 'media-top-content-bottom',
      }}
      imageContainerWidth='40%'
      imageFitPreset='cover-right'
      image={{
        alt: 'Colorful robot figure with stickers',
        desktop: {
          src: '/images/new/robot-arm-mail-v2.png',
          dimensions: { width: 527, height: 860 },
        },
        mobile: {
          src: '/images/new/robot-arm-mail.png',
          dimensions: { width: 550, height: 704 },
        },
      }}
    >
      <div className='d-flex flex-1 flex-column gap-4 px-4 pt-4 pb-5 pe-lg-10 pt-lg-13 pb-lg-7 mt-lg-0 mt-n16 ms-lg-n10'>
        <h2 className='fw-semibold fs-fluid-36-52 lh-105'>
          Set up your virtual office in <br className='d-none d-lg-block' />{' '}
          less than <span className='text-gradient-purple'>10 minutes</span>
        </h2>
        <span className='fw-semibold lh-132 lh-lg-119 fs-fluid-20-28'>
          Our Virtual Office London plan offers all the benefits of a prime
          London business address from just{' '}
          {getPlanPrice().monthlyOnYearlyPlan(PlanSlug.SCAN_LITE)} (when paid
          annually).
        </span>
        <p className='lh-132 fs-fluid-18-24'>
          Register your virtual office address to unlock AI-powered mail
          delivery. Use our address at Companies House to keep your home
          private.
          <br />
          <br />
          We receive, securely process, and digitise your mail with HaiRo™,
          sending it to you within 1 business day. Physical mail is stored for
          30 days before secure shredding.
          <br />
          <br />
          Need a physical copy? We forward mail anywhere in the UK or worldwide
          for the cost of postage + 50p processing fee.
        </p>
        <SubscriptionPricing
          planSummary={planSummary}
          buttonType={ButtonType.VIRTUAL_OFFICE_LONDON_MAIL_HANDLING_CTA}
          showCTABtnInRow
        />
      </div>
    </MediaCard>
  )
}

export default SetupVOin10
